import React from "react";
import { useQuery } from "react-query";
import useApi from "../../../hooks/useApi";
import PoliciesTable from "./PoliciesTable";

const PoliciesAwaitingRenewalTab = () => {
  const { api, auth } = useApi();

  const getPolicies = async () => {
    try {
      const url = `/policies/policy-items/awaiting`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data } = useQuery(["AwaitingPolicyItems", auth], ({ queryKey }) =>
    getPolicies()
  );

  return (
    <div className="table-responsive bg-white mb-3">
      <h1 className="py-2 text-center border-bottom border-2 border-primary">
        {(data && data?.length) || 0} expired polic
        {data && data?.length > 1 ? "ies" : "y"} awaiting renewal
      </h1>
      <PoliciesTable policies={data} />
    </div>
  );
};

export default PoliciesAwaitingRenewalTab;
